import { Button } from 'ui/Button';
import styles from './ActionRequiredAlertMobile.module.scss';
import { ReactComponent as IconAlert } from './img/iconAlert.svg';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { useState } from 'react';

export const ActionRequiredAlertMobile = ({
  tab,
  onClick,
  title,
  subtitle,
}: {
  tab: string;
  onClick: () => void;
  title: string;
  subtitle: string;
}) => {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;

  if (tab === 'customer-action-required' && title === 'Заказы требующие действия')
    return null;
  if (tab === 'approving_volume' && title === 'Подтверждение объема') return null;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.header_left}>
          <IconAlert />
          <span className={styles.header_title}>{title}</span>
        </div>
        <IconClose style={{ cursor: 'pointer' }} onClick={() => setHidden(true)} />
      </div>
      <div className={styles.body}>
        <span>{subtitle}</span>
      </div>
      <Button className={styles.btn} onClick={onClick} theme='filed'>
        Перейти
      </Button>
    </div>
  );
};
